/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

/** @jsx jsx */
import { jsx, css } from '@emotion/react'

import { EuiImage } from '@elastic/eui'

import type { SolutionType } from './types'
import type { FC } from 'react'

type SolutionPreviewProps = {
  selectedSolution?: SolutionType | null
  selectedImage: string | undefined
  imageTopPosition?: string
  imageMaxLeft?: string
  minWidth?: string
}

const SolutionPreview: FC<SolutionPreviewProps> = ({
  selectedSolution,
  selectedImage,
  imageTopPosition = '239px',
  imageMaxLeft = '760px',
  minWidth = '1024px',
}) => (
  <div
    css={css`
      position: fixed;
      top: ${imageTopPosition};
      right: 0;
      left: max(${imageMaxLeft}, calc(100vw - 712px));
      height: 100vh;
      overflow: visible;
      @media (max-width: ${minWidth}) {
        display: none;
      }
    `}
  >
    {selectedImage && (
      <EuiImage
        src={selectedImage}
        alt={selectedSolution ? `${selectedSolution} solution preview` : 'Default solution preview'}
        size='full'
        css={css`
          max-width: none;
          height: 100vh;
          min-height: 848px;
        `}
      />
    )}
  </div>
)

export default SolutionPreview
